function PageNotFound () {
    return(
        <p>404 Page not found</p>
    );
}

export default PageNotFound;